import { useRef, useEffect, useState } from 'react';
import { Position } from 'shamrock-clover-ui/dist/clover/components/Snackbar/Snackbar';

interface ClassType<T> {
    new(): T
  }

export const useInstance = <T>(ToInstance: ClassType<T>): T => {
  const instanceRef = useRef<T | null>();
  if (!instanceRef.current) {
    instanceRef.current = new ToInstance();
  }
  useEffect(() => () => instanceRef.current = null, []);

  return instanceRef.current;
};

export type SnackBarProps = {
  open: boolean;
  duration?: number;
  message: string;
  variant: 'info' | 'error' | 'success';
  position?: Position;
};

export const defaultSnackBarProps: SnackBarProps = {
  open: false,
  duration: 180000,
  message: '',
  variant: 'info',
  position: 'topCenter',
};

export const useSnackBarState = () => useState<SnackBarProps>({open: false, ...defaultSnackBarProps });

